window.addEventListener("load", (event) => {
  (function () {
    class BannerSlideshow extends HTMLElement {
      constructor() {
        super();
        this.currentSlide = 0;
        this.autoplayInterval = null;
      }

      connectedCallback() {
        this.track = this.querySelector('.c-image-banner-slideshow__track');
        this.slides = this.querySelectorAll('.c-image-banner-slideshow__slide');
        this.prevButton = this.querySelector('.c-image-banner-slideshow__nav-button--prev');
        this.nextButton = this.querySelector('.c-image-banner-slideshow__nav-button--next');
        this.dots = this.querySelectorAll('.c-image-banner-slideshow__dot');
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;

        if (this.slides.length <= 1) return;

        this.setupEventListeners();

        if (this.autoplay) {
          this.startAutoplay();
        }
      }

      setupEventListeners() {
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.goToPrevSlide());
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.goToNextSlide());
        }

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => {
          if (this.autoplay) {
            this.startAutoplay();
          }
        });
      }

      goToSlide(index) {
        this.currentSlide = index;
        this.updateSlidePosition();
        this.updateDots();
      }

      goToNextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.updateSlidePosition();
        this.updateDots();
      }

      goToPrevSlide() {
        this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
        this.updateSlidePosition();
        this.updateDots();
      }

      updateSlidePosition() {
        const offset = -this.currentSlide * 100;
        this.track.style.transform = `translateX(${offset}%)`;
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          if (index === this.currentSlide) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      startAutoplay() {
        this.stopAutoplay();
        this.autoplayInterval = setInterval(() => {
          this.goToNextSlide();
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
          this.autoplayInterval = null;
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }
    }

    customElements.define('banner-slideshow', BannerSlideshow);
  })();
});
  
